import React from "react";
import { Box, Modal, Typography, Button } from "@mui/material";

interface AccessCheckStatusModalProps {
  open: boolean;
  onClose: () => void;
}

const style = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '300px', 
    padding: '20px',
    backgroundColor: '#e3f2fd', 
    borderRadius: '12px',
    boxShadow: 1,
    zIndex: 1300,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
};

const AccessCheckStatusModal: React.FC<AccessCheckStatusModalProps> = ({ open, onClose }) => {
  return (
    <Modal 
      open={open} 
      onClose={onClose}
      BackdropProps={{ invisible: true }} 
    >
      <Box sx={style}>
        <Typography variant="h6" gutterBottom>
          Access Denied
        </Typography>
        <Typography variant="body2" gutterBottom>
          You don't have access to add the Remarks or Amount.
        </Typography>
        <Button onClick={onClose} variant="contained" sx={{ mt: 2 }}>
          OK
        </Button>
      </Box>
    </Modal>
  );
};

export default AccessCheckStatusModal;
